import { ITag, TagType } from 'api-paths-cas';
import { MultiIntakeTag } from './types/multiIntake';
import { PathwayTag } from './types/pathway';
import { VisaGapTag } from './types/visaGap';
import { UKTag } from './types/12MonthsUk';
import { EussGrantedTag } from './types/eussGranted';
import { EussPendingTag } from './types/eussPending';
import { CustomeTag } from './types/custome';
import { ManualCasTag } from './types/manualCas';
import { TagProps } from '@chakra-ui/react';
import { TransfermateTag } from './types/transfermate';

export interface IProps {
  tag: ITag;
  onClick: any;
  canDelete?: boolean;
  tagProps?: TagProps;
}

export const TagComponent = ({ tag, onClick, canDelete, tagProps }: IProps) => {
  const tagType = tag.type ? tag.type : tag.id;
  switch (tagType) {
    case TagType.OVER_28_DAYS_VISA_GAP:
    case TagType.UNDER_28_DAYS_VISA_GAP: {
      return <VisaGapTag tag={tag} onClick={onClick} canDelete={canDelete!} tagProps={tagProps} />;
    }
    case TagType.OVER_12_MONTHS_UK:
    case TagType.UNDER_12_MONTHS_UK: {
      return <UKTag tag={tag as any} tagProps={tagProps} />;
    }
    case TagType.PATHWAY: {
      return <PathwayTag tag={tag} tagProps={tagProps} />;
    }
    case TagType.EUSS_GRANTED:
      return <EussGrantedTag tag={tag} tagProps={tagProps} />;
    case TagType.EUSS_PENDING:
      return <EussPendingTag tag={tag} tagProps={tagProps} />;
    case TagType.MULTI_INTAKE:
      return <MultiIntakeTag tag={tag} tagProps={tagProps} />;
    case TagType.MANUAL_CAS:
      return <ManualCasTag tag={tag} tagProps={tagProps} />;
    case TagType.TRANSFERMATE:
      return <TransfermateTag tag={tag} tagProps={tagProps} />;
  }
  return <CustomeTag tag={tag} onClick={onClick} canDelete={canDelete!} tagProps={tagProps} />;
};
